"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTrophy2 = function SvgIconTrophy2(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "trophy 2 icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Trophy 2 Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.333 10.483h-7.222V7.68A1.67 1.67 0 0033.444 6H14.556a1.67 1.67 0 00-1.667 1.681v2.802H5.667A1.67 1.67 0 004 12.163v3.923c0 4.658 5.41 9.225 11.938 9.974 2.18 3.65 4.729 5.156 4.729 5.156v5.043h-3.334c-2.451 0-4.444 1.45-4.444 3.922v.84a.84.84 0 00.833.841h20.556a.84.84 0 00.833-.84v-.841c0-2.472-1.993-3.922-4.444-3.922h-3.334v-5.043s2.549-1.506 4.73-5.156C38.61 25.304 44 20.73 44 16.086v-3.922a1.67 1.67 0 00-1.667-1.681zM8.444 16.086v-1.12h4.459c.07 2.283.403 4.286.889 6.037-3.299-1.148-5.348-3.495-5.348-4.917zM24.525 10c3.043 0 4.723 1.736 4.723 4.05 0 2.26-1.867 3.342-3.621 4.275-1.4.747-2.688 1.4-2.875 2.446h6.384v3.042h-9.819v-2.445c0-2.707 2.147-4.013 4.014-5.021 1.512-.803 2.688-1.363 2.688-2.315 0-.765-.523-1.232-1.568-1.232-1.251 0-2.166.84-2.52 1.867L19 13.285C20.027 11.288 21.968 10 24.525 10zm15.03 4.966v1.12c0 1.415-2.041 3.769-5.347 4.917.486-1.75.82-3.754.89-6.037h4.458z"
  }));
};

var _default = SvgIconTrophy2;
exports.default = _default;